import PropTypes from 'prop-types';
import React from 'react';

import ImagePlaceholder from 'components/shared/image-placeholder';
import Link from 'components/shared/link';

const AuthorPhoto = ({ authorPhoto, authorName, authorPosition, readMoreUrl }) => (
  <div className="mt-8 flex items-center justify-between md:mt-6 md:block">
    <div className="flex items-center space-x-5">
      <div className="relative w-16 shrink-0 md:w-14">
        <img
          className="absolute top-0 left-0 h-full w-full rounded-full"
          src={authorPhoto.url}
          alt={authorName}
          loading="lazy"
          height={64}
          width={64}
        />
        <ImagePlaceholder width={64} height={64} />
      </div>
      <div className="space-y-0.5">
        <span className="block font-bold">{authorName}</span>
        <span className="block text-base">{authorPosition}</span>
      </div>
    </div>
    {readMoreUrl && (
      <Link className="md:mt-6" to={readMoreUrl} size="sm" theme="black-underline">
        Read more
      </Link>
    )}
  </div>
);

AuthorPhoto.propTypes = {
  authorPhoto: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
  authorName: PropTypes.string.isRequired,
  authorPosition: PropTypes.string.isRequired,
  readMoreUrl: PropTypes.string,
};

export default AuthorPhoto;
